import { Paper, Typography, Button, Grid } from "@material-ui/core"
import { useDispatch } from "react-redux";
import useStyles from "./styles"

import { deletePost } from "./../../../../actions/posts";

const Post = ({ post, setCurrentId }) =>
{

  const classes = useStyles();
  const dispatch = useDispatch();

  return (
    <Paper className={classes.post} variant="outlined">
      <Typography className={classes.text} variant="h6">Title: {post.title}</Typography><br />
      <Typography className={classes.text} variant="h6">{post.progress}</Typography><br />
      <Typography className={classes.text} variant="h6">Score: {post.rating}</Typography><br />
      <Typography className={classes.text} variant="h6">Comments: {post.comment}</Typography><br />
      <Button onClick={() => setCurrentId(post._id)}>Edit</Button>
      <Button onClick={() => dispatch(deletePost(post._id))}>Delete</Button><br />
      <img className={classes.post_image} src={post.image.src} alt="fuck"></img>
    </Paper>
  );
}

export default Post;